module.exports = __webpack_public_path__ + "img/logo2-mobile.fc7a36be.png";